import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Formjob() {
  const [Career, setCareer] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/opening_list"
      );
      setCareer(response.data.data);
    };

    fetchData();
  }, []);

  return (
    <>
      <div className="container-fluid mb-5 ">
        <div className="container">
          <h1 className="job-heading text-center">
            <strong>Job Openings.</strong>
          </h1>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-lg-9 mx-auto">
              <div id="kh-job-wedget" className="col-md-12 col-sm-12">
                <div className="kh-mb-3 kh-row kh-no-gutters kh-w-100">
                  <h1
                    className="engi-data kh-font-weight-600 kh-col-sm-12 kh-mb-16 kh-mt-0 kh-d-flex kh-align-items-center kh-flex-wrap kh-text-truncate-2"
                    title="Engineering"
                  >
                    Engineering
                  </h1>

                  <div className="container">
                    <div className="row justify-content-center">
                      {Career.map((Data, index) => (
                        <div
                          className="col-lg-6 col-md-6 d-flex justify-content-center"
                          key={index}
                        >
                          <div className="kh-col-sm-12 kh-mb-9 kh-col-md-6">
                            {/* ✅ Pass job_id in the URL */}
                            <Link
                              to={`/project1/${Data.job_id}`}
                              className="kh-card kh-job-card kh-h-100 kh-job-container"
                            >
                              <div className="kh-card-body kh-d-flex kh-flex-column kh-py-3">
                                <div className="kh-d-flex kh-align-items-center kh-justify-content-between">
                                  <div className="kh-w-100">
                                    <div className="kh-d-flex kh-align-items-center kh-mb-1 kh-flex-wrap">
                                      <h3
                                        className="kh-job-title kh-text-truncate-1 kh-text-dark kh-font-weight-600 kh-mb-0 kh-mr-2"
                                      >
                                        {Data.job_heading}
                                      </h3>
                                    </div>
                                    <div className="kh-d-flex kh-text-secondary kh-align-items-center mt-auto">
                                      <div className="kh-d-flex kh-align-items-center kh-flex-wrap">
                                        <span
                                          className="kh-font-large kh-text-capitalize kh-text-truncate-1 kh-mr-1"
                                          dangerouslySetInnerHTML={{
                                            __html: Data.job_experience,
                                          }}
                                        ></span>
                                      </div>
                                    </div>
                                  </div>

                                 {/* ✅ Right Arrow */}
<div className="kh-px-1 kh-d-none kh-d-md-block">
<Link to={`/project1/${Data.job_id}`} onClick={() => console.log("Clicked job_id:", Data.job_id)}>
  <i className="fa-solid fa-circle-arrow-right"></i>
</Link>
</div>

                                </div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Formjob;
